module.exports = __webpack_public_path__ + "static/garden2-06726a4a3865140cc92870fe90819d42.jpg";